import styled from 'styled-components';

import { getWidgetSpacing } from '../utils';

export const HeadingText = styled.h1`
  color: ${Styles.color.loyaltyHighlight};
  font-family: ${Styles.fontFamily.brand};
  font-size: 1.375rem;
  text-align: left;
  margin: 0 0 0 ${getWidgetSpacing.horizontal()};

  ${Styles.desktop`
    text-align: left;
    font-size: 1.625rem;
    margin: 0 0 ${getWidgetSpacing.vertical()};
  `}
`;

export const LoadingContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 12rem;
  width: 100%;

  svg {
    fill: ${Styles.color.primary};
  }
`;

export const Container = styled.section`
  padding: ${getWidgetSpacing.vertical()} 0 0;
  background-color: ${Styles.color.teal};
  ${Styles.desktop`
    padding: ${getWidgetSpacing.vertical('desktop')} 0;
  `};
`;
